module.exports = {"pathContext":{"slug":"/es/corporate_program/","langKey":"es"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/es-corporate-program.json
// module id = 1190
// module chunks = 165001943843510